import jwt from "jsonwebtoken"
import React, { useState } from "react"
import { Card, CardBody, Button, Spinner } from "reactstrap"
import { connect } from "react-redux"
import { useWallet } from "../libs/useMetaMaskWallet"
import LoginToMetamask from "../Components/LoginToMetamask"
import OkDialog from "./OkDialog"

const NFTUpgrade = (props) => {
    const { kycStatus } = props
    const wallet = useWallet()
    const [dialogMessage, setDialogMessage] = useState("")
    const [showSpinner, setShowSpinner] = useState(false)

    if (kycStatus !== "approved") {
        return (
            <React.Fragment>
                <div className="content">
                    <Card>
                        <CardBody>
                            <p>Please wait for KYC approval to access this information.</p>
                        </CardBody>
                    </Card>
                </div>
            </React.Fragment>
        )
    }

    const handleClickClaim = async (event) => {
        setShowSpinner(true)
        const userFractalId = localStorage.getItem("userFractalId")
        if (!userFractalId) {
            setDialogMessage("Fractal ID not found!")
            setShowSpinner(false)
        } else {
            var decoded = jwt.decode(localStorage.jwtToken)
            if (!decoded || !decoded.email) {
                setDialogMessage("Invalid JWT token! Please logout and back in.")
                setShowSpinner(false)
            } else {
                fetch("https://blxm.bloxmove.net/api/v1/wallets", {
                    method: "POST",
                    body: JSON.stringify({
                        email: decoded.email,
                        token: localStorage.jwtToken,
                        address: wallet.account,
                        kyc_profile: userFractalId
                    }),
                    headers: { "Content-Type": "application/json" },
                    json: true
                })
                    .then((response) => {
                        if (response.ok) {
                            localStorage.setItem("bloxmove_claim_response", JSON.stringify(response))
                            window.location.replace("https://blxm.bloxmove.net/")
                        } else {
                            setDialogMessage("Error connecting to bloxmove, please try again later")
                            setShowSpinner(false)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        setDialogMessage("Error from bloxmove: " + String(error))
                        setShowSpinner(false)
                    })
            }
        }
    }

    return (
        <React.Fragment>
            <div className="content">
                <Card>
                    <CardBody>
                        {wallet.account ? (
                            <React.Fragment>
                                <p>
                                    {/* You are KYC approved. You may now send USDT funds to 'walletAddress'. Please send these from the same wallet address as
                                    your NFT, however please use the Ethereum network to send, not Polygon. If you prefer to use a different wallet address,
                                    please enter and save it in the below form before sending. */}
                                    You are KYC approved. Please click on the button below to go to the bloxmove website to complete the purchase.
                                </p>

                                <Button color="primary" className="waves-effect mb-3" onClick={handleClickClaim} disabled={true | showSpinner}>
                                    {showSpinner ? (
                                        <React.Fragment>
                                            Claiming...
                                            <Spinner style={{ width: "0.7rem", height: "0.7rem", marginLeft: "1rem" }} color="light" />
                                        </React.Fragment>
                                    ) : (
                                        "Sold Out" //"Claim"
                                    )}
                                </Button>

                                <OkDialog open={dialogMessage} title={""} message={dialogMessage} okClick={() => setDialogMessage("")} />
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <p>You are KYC approved. However, you must login to MetaMask before claiming!</p>
                                <LoginToMetamask />
                            </React.Fragment>
                        )}
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    kycStatus: state.commonReducer.kycStatus
})

export default connect(mapStateToProps)(NFTUpgrade)
